"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Alert_component_exports = {};
__export(Alert_component_exports, {
  Alert: () => Alert
});
module.exports = __toCommonJS(Alert_component_exports);
var import_react = __toESM(require("react"));
var import_atoms = require("../../atoms");
var import_react_i18next = require("react-i18next");
var import_uniqueId = __toESM(require("lodash/uniqueId"));
var import_useBreakpoints = require("../../../utils/useBreakpoints/useBreakpoints.hook");
var import_Alert = require("./Alert.styled");
var _excluded = ["alertType", "alertVariant", "visible", "hideIcon", "maxWidth"];
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var defaultIcons = {
  neutral: "information-plain",
  success: "check",
  warning: "warning",
  error: "x"
};
var Alert = function Alert2(_ref) {
  var _ref$alertType = _ref.alertType, alertType = _ref$alertType === void 0 ? "toast" : _ref$alertType, _ref$alertVariant = _ref.alertVariant, alertVariant = _ref$alertVariant === void 0 ? "neutral" : _ref$alertVariant, _ref$visible = _ref.visible, visible = _ref$visible === void 0 ? true : _ref$visible, _ref$hideIcon = _ref.hideIcon, hideIcon = _ref$hideIcon === void 0 ? false : _ref$hideIcon, maxWidth = _ref.maxWidth, props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, import_react.useState)(visible), _useState2 = _slicedToArray(_useState, 2), isVisible = _useState2[0], setIsVisible = _useState2[1];
  var titleId = "title-".concat(props.id || (0, import_uniqueId.default)());
  var contentId = "message-".concat(props.id || (0, import_uniqueId.default)());
  var breakpoints = (0, import_useBreakpoints.useBreakpoints)();
  var maxWidthDefault = breakpoints.isMd ? "520px" : "720px";
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  (0, import_react.useEffect)(function() {
    var timer = props.timeout && setTimeout(function() {
      return setIsVisible(false);
    }, props.timeout);
    return function() {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [props.timeout]);
  var handleOnClose = function handleOnClose2(ev) {
    setIsVisible(!isVisible);
    if (props.handleClose) {
      props.handleClose(ev);
    }
  };
  if (!isVisible)
    return null;
  function isAContentType(obj) {
    return obj && ("title" in obj || "message" in obj);
  }
  function getRole() {
    if (props.role) {
      return props.role;
    }
    return alertType === "banner" ? "alert" : "alertdialog";
  }
  function getAriaLabelLedBy() {
    if (getRole() === "alertdialog") {
      return props.ariaLabelledby ? props.ariaLabelledby : titleId;
    }
    return null;
  }
  function getDescribedBy() {
    if (getRole() === "alertdialog") {
      return props.ariaDescribedby ? props.ariaDescribedby : contentId;
    }
    return null;
  }
  function renderContent(contentProp) {
    if (isAContentType(contentProp)) {
      return /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, contentProp.title && /* @__PURE__ */ import_react.default.createElement(import_Alert.StyledSpan, {
        id: titleId
      }, /* @__PURE__ */ import_react.default.createElement("strong", null, contentProp.title)), contentProp.message && /* @__PURE__ */ import_react.default.createElement("p", {
        id: contentId,
        className: "message"
      }, contentProp.message));
    }
    return /* @__PURE__ */ (0, import_react.isValidElement)(contentProp) && contentProp;
  }
  return /* @__PURE__ */ import_react.default.createElement(import_Alert.StyledAlert, {
    "data-testid": "test-alert",
    alertType,
    variant: alertVariant,
    role: getRole(),
    maxWidth: maxWidth || maxWidthDefault,
    "aria-labelledby": getAriaLabelLedBy(),
    "aria-describedby": getDescribedBy(),
    "aria-label": props.ariaLabel
  }, /* @__PURE__ */ import_react.default.createElement(import_Alert.StyledIconContainer, null, !hideIcon && /* @__PURE__ */ import_react.default.createElement(import_Alert.IconWrapper, {
    "data-testid": "test-alert-icon-wrapper",
    variant: alertVariant,
    className: "icon-wrapper"
  }, /* @__PURE__ */ import_react.default.createElement(import_atoms.Icon, {
    icon: props.customIcon || defaultIcons[alertVariant]
  }))), /* @__PURE__ */ import_react.default.createElement(import_Alert.StyledContentContainer, {
    existSecondAction: !!props.SecondAction
  }, /* @__PURE__ */ import_react.default.createElement(import_Alert.AlertHeading, null, /* @__PURE__ */ import_react.default.createElement(import_Alert.ContentWrapper, {
    "data-testid": "test-alert-content",
    className: "content-wrapper"
  }, renderContent(props.content))), /* @__PURE__ */ (0, import_react.isValidElement)(props.content) && /* @__PURE__ */ import_react.default.createElement(import_Alert.MessageAlert, {
    existsActions: !!(props.FirstAction || props.SecondAction)
  }), (props.FirstAction || props.SecondAction) && /* @__PURE__ */ import_react.default.createElement(import_Alert.ActionsWrapper, {
    "data-testid": "test-alert-actions",
    marginBetween: !!(props.FirstAction && props.SecondAction),
    existSecondAction: !!props.SecondAction,
    className: "actions-wrapper"
  }, props.FirstAction && props.FirstAction, props.SecondAction && props.SecondAction)), /* @__PURE__ */ import_react.default.createElement(import_Alert.CloseWrapper, null, /* @__PURE__ */ import_react.default.createElement(import_atoms.Button, {
    ariaLabel: t("base_action_closeAlert"),
    circle: true,
    "data-testid": "test-close-btn",
    icon: "x",
    onClick: handleOnClose,
    variant: "empty",
    size: "20px",
    className: "outer-close-button",
    "data-dp-analytics-id": props.closeButtonDataDpAnalyticsId
  })));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Alert
});
//# sourceMappingURL=Alert.component.js.map